// components/Banner.jsx
import React from 'react';
import BannerImage from '../assets/banner.png';

export default function Banner() {
  return (
    <div
      className="w-full h-64 bg-cover bg-center"
      style={{ backgroundImage: `url(${BannerImage})` }}
    >
      {/* Banner da saúde */}
    </div>
  );
}